import { useMutation } from "react-query";
import getRegtankLivenessWebVerifyLink from "../services/getRegtankLivenessWebVerifyLink";

function useGetLivenessWebVerifyLink() {
  return useMutation(
    ["regtank-liveness-webverify"],
    getRegtankLivenessWebVerifyLink
  );
}

export default useGetLivenessWebVerifyLink;
